export default {
    title: '公司會員管理'
}
